import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OpcionesService, PanelItemOpcionesVM } from '../../infrastructure/services/opciones.service';
import { LoaderService } from '../../infrastructure/services/loader.service';
import { Location } from '@angular/common';
import { ProvidersService } from '../../infrastructure/services/providers.service';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';

@Component({
  templateUrl: 'controller.opcion.component.html'
})
export class ControllerOpcionComponent implements OnInit {
  codSistema: string;
  codNegocio: string;
  codProducto: string;
  accion: String;
  idOpcion: number;
  TipoCotizador: string;
  CodSubProductoInbroker: string;
  CodPlan: string;
  NroOpcionNegocio: number;
  opcion: PanelItemOpcionesVM;
  esNuevo: boolean;
  // tipoCotizaciones= ['INBKV5', 'HUBMX', 'HUBAR'];
  tipoCotizaciones: ItemGeneralListado[];
  ready = false;

  constructor(private aRoute: ActivatedRoute,
    private opcionService: OpcionesService,
    private location: Location,
    private providerService: ProvidersService) { }

  ngOnInit() {
    this.aRoute.params.subscribe(params => {
      this.codSistema = params['codsistema'];
      this.codNegocio = params['codnegocio'];
      this.codProducto = params['codproducto'];
      this.accion = params['accion'];

      this.providerService.getForList().subscribe((response: ItemGeneralListado[]) => {
        this.tipoCotizaciones = response;
      });

      /*this.opcion = {
        commercialProductId: -1,
        subscriptionCode: this.CodSubProductoInbroker,
        codPlan: this.CodPlan,
        description: this.NroOpcionNegocio,
        tipoCotizador: this.TipoCotizador,
        codInstalacionV5: this.codSistema,
        codNegocio: this.codNegocio,
        codProducto: this.codProducto
      };*/

      // Si estoy creando un nuevo Asset
      if (this.accion === 'nuevo') {
        this.ready = true;
        this.opcion = {
          commercialProductId: -1,
          optionNumber: undefined,
          codSubProduct: undefined,
          codPlan: undefined,
          subscriptionCode: undefined,
        } as PanelItemOpcionesVM;
        return;
      }

      this.idOpcion = params['idOpcion'];

      // Si estoy editando un asset existente
      this.opcionService
        .getByID(this.idOpcion)
        .then(res => {
          this.opcion = res;
          this.ready = true;
        });
    });
  }

  guardar() {
    // this.opcion.tipoCotizador = this.TipoCotizador;
    this.opcionService.crearOpcion(this.codSistema, this.codNegocio, this.codProducto, this.opcion)
      .then(this.volverAlListado.bind(this));
  }

  editar() {
    // this.opcion.tipoCotizador = this.TipoCotizador;
    // this.opcion.idOpcionNegocio = this.idOpcion;

    this.opcionService.editarOpcion(this.opcion)
      .then(this.volverAlListado.bind(this));
  }

  private volverAlListado() {
    this.location.back();
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/opciones/controller.opcion.component.ts